import React from 'react';
import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import {
  amlInitiateButtonSx,
  amlInitialStateSx,
  amlResultContainerSx,
  getAmlInitialMessageSx,
  getAmlResultSubtitleSx,
  getAmlResultTitleSx,
} from './amlScreeningStyles';

export default function AmlScreeningInitialPanel({ labels = {}, onInitiate, isRunning = false }) {
  const theme = useTheme();

  const title = labels.title ?? 'AML Screening';
  const subtitle = labels.subtitle ?? 'Anti-Money Laundering checks against global compliance watchlists.';
  const message = labels.message ?? 'Anti-Money Laundering (AML) check has not been initiated for this entity yet.';
  const initiateLabel = labels.initiateButton ?? 'Initiate AML Check';

  return (
    <Box sx={amlResultContainerSx}>
      <Typography sx={getAmlResultTitleSx(theme)}>{title}</Typography>
      <Typography sx={getAmlResultSubtitleSx(theme)}>{subtitle}</Typography>

      <Box sx={amlInitialStateSx}>
        <Box sx={{ position: 'relative', display: 'inline-flex', color: 'text.disabled' }}>
          <ShieldOutlinedIcon sx={{ fontSize: 56 }} />
          <SearchOutlinedIcon
            sx={{
              fontSize: 22,
              position: 'absolute',
              bottom: -2,
              right: -6,
            }}
          />
        </Box>

        <Typography sx={getAmlInitialMessageSx(theme)}>{message}</Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={onInitiate}
          disabled={isRunning}
          startIcon={isRunning ? <CircularProgress size={18} color="inherit" /> : null}
          sx={amlInitiateButtonSx}
        >
          {initiateLabel}
        </Button>
      </Box>
    </Box>
  );
}
